<template>
  <div>
    <div :style="listHeight">
      <el-scrollbar style="height:100%;">
        <div class="Details" style="height:500px;">
          <el-table
            :data="relationList"
            empty-text
            border
            style="width: 1200px; margin: auto; text-align:center;"
            highlight-current-row
            @current-change="onFocus"
            @cell-dblclick="relationDetails"
          >
            <el-table-column
              prop="LINKCREATEUSERNAME"
              label="创建人"
              width="180"
              style="text-align:center;"
            ></el-table-column>
            <el-table-column prop="LinkName" label="任务名称"></el-table-column>
            <el-table-column prop="LINKCREATETIME" label="创建时间" width="180"></el-table-column>
            <el-table-column prop="LINKSERVERCENTERNAME" label="服务台"></el-table-column>
            <el-table-column prop="LINKEXCUTEUSERNAME" label="执行人" width="180"></el-table-column>
            <el-table-column label="关联关系" width="180">
              <template slot-scope="scope">
                <div
                  v-if="selectShow !== scope.$index"
                  @click="selectClick(scope.$index)"
                >{{ scope.row.RELATIONTYPE|relationTypeFilters }}<i class="el-icon-edit" style="color:#ff0000;float: right;"></i></div>
                <el-select
                  v-else
                  v-model="selectValue"
                  size="mini"
                  @change="selectChange"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="items in taskOptions"
                    :key="items.value"
                    :label="items.label"
                    :value="items.value"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-scrollbar>
    </div>
    <div class="button">
      <el-button
        type="primary"
        class="add"
        @click="showDialogCreateTask"
        size="mini"
        icon="el-icon-circle-plus-outline"
      >新建</el-button>
      <el-button
        type="primary"
        class="add"
        @click="showDialogTask"
        size="mini"
        icon="el-icon-circle-plus-outline"
      >添加</el-button>
      <el-button type="danger" class="delete" @click="onDelete" size="mini">删除</el-button>
    </div>
    <CreateItem ref="CreateItem" @getValue="getCreateItem"></CreateItem>
    <taskDialog ref="taskDialog" @getValue="getTaskDialogs"></taskDialog>
  </div>
</template>
<script>
import {
  GetAllRelationsBySelectIndex,
  DelRelation,
  addRelation,
  UpdateRelation
} from "@/api/modules/basicData/task";
import { getToken } from "@/util/auth";
const cookieUser = getToken();
import CreateItem from "./CreateItem.vue";
// import taskDialog from '@/components/basicTemplate/common/taskDialog.vue'
export default {
  components: {
    CreateItem,
    taskDialog: () =>
      import("@/components/basicTemplate/common/taskDialog.vue"),
    UpdateRelation
  },
  data() {
    return {
      relationList: {},
      taskId: "",
      selectValue: "",
      selectShow: 99999,
      taskOptions: [
        { label: "普通关系", value: 0 },
        { label: "完成 - 开始", value: 1 },
        { label: "开始 - 开始", value: 2 },
        { label: "完成 - 完成", value: 3 },
        { label: "开始 - 完成", value: 4 }
      ]
    };
  },
  created() {
    let a = $(window).height();
    this.listHeight = "height:" + (a - 190) + "px;";
  },
  methods: {
    initalTask: function() {
      if (!this.task || this.tabIndex !== "6") return;
      GetAllRelationsBySelectIndex(this.task.ID, 0, 0).then(res => {
        this.relationList = res;
        console.log("返回值1", this.relationList);
        if (!res) return;
        // alert(JSON.stringify(res))
        res.filter(item => {
          var nub = "";
          var nub2 = "";
          if(item.LINKCREATETIME) {
            var string = item.LINKCREATETIME.split("");
            string.splice(10, 1);
            for (let i = 0; i < 18; i++) {
              if (i < 10) {
                nub = nub + string[i];
              } else {
                nub2 = nub2 + string[i];
              }
            }
            item.LINKCREATETIME = nub + " " + nub2;
          }
        });
        this.relationList = res;
        console.log("返回值2", this.relationList);
      });
    },
    /**
     * 获取任务类型数据
     */
    onFocus: function(row) {
      this.taskId = row.ID;
    },
    onDelete: function() {
      if (!this.taskId) return;
      const user = getToken();
      let person = {
        ID: user.userId,
        NAME: user.realName,
        DEPTID: user.departmentId,
        DEPTNAME: user.departmentName,
        COMPANYID: user.organizationId,
        COMPANYNAME: ""
      };
      DelRelation(this.taskId, person).then(pmevent => {
        if (pmevent.ResultCode === 1) {
          this.initalTask();
          this.$message({
            type: "success",
            message: "删除任务关联成功。"
          });
        } else {
          this.$message({
            type: "error",
            message: "删除任务关联失败！"
          });
        }
      });
    },
    selectClick(e) {
      // 选中表格关联关系，切换成选择框
      this.selectShow = e;
    },
    selectChange(e) {
      // 选中关联关系选择框，切换成原样式，影藏选择框
      console.log(e);
      console.log(this.relationList[this.selectShow]);
      let val = this.relationList[this.selectShow];
      // this.relationList[this.selectShow].RELATIONTYPE = e;
      this.selectShow = 9999;
      const cookieUser = getToken();
      var person = {
        ID: cookieUser.userId,
        NAME: cookieUser.realName,
        DEPTID: cookieUser.departmentId,
        DEPTNAME: cookieUser.departmentName,
        COMPANYID: cookieUser.organizationId,
        COMPANYNAME: cookieUser.organizationName
      };
      var relation = {
        ID: val.ID,
        MAINID: val.MAINID,
        INSTANCE: val.INSTANCE,
        STATE: val.STATE,
        LINKID: val.LINKID,
        LINKINSTANCE: val.LINKINSTANCE,
        LINKSTATE: val.LINKSTATE,
        RELATIONTYPE: e,
        DIRECTION: 0,
        NOTICETYPE: 0
      };
      UpdateRelation(relation, person).then(item => {
        if (item.ResultCode === 1) {
          this.initalTask();
          this.$message({
            type: "success",
            message: "修改关联成功。"
          });
        } else {
          this.$message({
            type: "error",
            message: "修改关联失败！"
          });
        }
      });
    },
    getCreateItem(rows) {
      // 新建关联任务返回值
      console.log("新建返回值:", rows);
      this.initalTask();
    },
    showDialogCreateTask() {
      // 打开新建关联任务弹窗
      let task = this.task;
      let value = {
        MAINID: task.ID,
        LINKID: "",
        INSTANCE: task.INSTANCE,
        STATE: task.STATE,
        LINKSTATE: "",
        DIRECTION: 1,
        RELATIONTYPE: 0,
        NOTICETYPE: -1
      };
      console.log("task:", value);
      this.$refs.CreateItem.dialogVisible = true;
      this.$refs.CreateItem.PM_RELATION = value;
      this.$refs.CreateItem.Relation = 1;
    },
    getTaskDialogs(rows) {
      console.log("弹窗返回", rows)
      let task = this.task;
      let relationList = this.relationList
      let _this = this
      let nub = 0
      rows.filter(function(row) {
        if(row.ID === task.ID){
          nub = 1
        }
        relationList.filter(function(val) {
          if(val.LINKID === row.ID) {
            nub = 1
          }
        })
      })
      if(nub === 0) {
        this.getTaskDialogsAjax(rows)
      } else {
        this.$message({
          type: "warning",
          message: "不能添加已有任务或添加本任务。"
        })
      }
    },
    getTaskDialogsAjax(rows) {
      console.log("弹窗返回", rows)
      let val = [];
      let task = this.task;
      rows.filter(function(row) {
        let value = {
          MAINID: task.ID,
          LINKID: row.ID,
          INSTANCE: task.INSTANCE,
          LINKINSTANCE: row.INSTANCE,
          STATE: task.STATE,
          LINKSTATE: row.STATE,
          DIRECTION: 1,
          RELATIONTYPE: 0,
          NOTICETYPE: -1
        };
        val.push(value);
      });
      const user = getToken();
      let paras = {
        Person: {
          ID: user.userId,
          NAME: user.realName,
          DEPTID: user.departmentId,
          DEPTNAME: user.departmentName,
          COMPANYID: user.organizationId,
          COMPANYNAME: ""
        },
        Relations: val
      };
      addRelation(paras).then(pmevent => {
        if (pmevent.ResultCode === 1) {
          this.initalTask();
          this.$message({
            type: "success",
            message: "添加任务关联成功。"
          });
        } else {
          this.$message({
            type: "error",
            message: "添加任务关联失败！"
          });
        }
      });
    },
    showDialogTask() {
      // 打开添加关联任务弹窗
      this.$refs.taskDialog.dialogVisible = true;
    },
    relationDetails(val) {
    //  双击打开详情
      let routeUrl = this.$router.resolve({
        path: "/task-detailspage",
        query: { taskid: val.LINKID}
      });
      window.open(routeUrl.href, "_blank");
    }
  },
  filters: {
    relationTypeFilters: function(val) {
      switch (val) {
        case 0:
          return "普通关系";
        case 1:
          return "完成-开始";
        case 2:
          return "开始-开始";
        case 3:
          return "完成-完成";
        case 4:
          return "开始-完成";
        default:
          return "";
      }
    }
  },
  computed: {
    task: function() {
      return this.$store.state.task.curTask;
    },
    tabIndex: function() {
      return this.$store.state.task.tabIndex;
    }
  },
  watch: {
    task: function(newvalue) {
      if (!newvalue) return;
      this.initalTask();
    },
    tabIndex: function(newvalue) {
      if (!newvalue) return;
      this.initalTask();
    }
  }
};
</script>

<style scoped>
.Details {
  margin: 15px 10px 0px 10px;
  text-align: left;
}
.button {
  margin: 15px 0 15px 20px;
  float: left;
}
.button .add {
  background: #ecf5ff;
  color: #0099ff;
}
.button .delete {
  background: #f9ebed;
  color: #f02d52;
  border: solid 1px #f02d52;
}
</style>
